import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import EditJob from './EditJob';

const queryClient = new QueryClient({
  defaultOptions: { queries: { refetchOnWindowFocus: false } }
});

export interface IEditJobProps {
  jobId: number;
  jobFeedActive: boolean;
  canAddIndeedDemographicQ: boolean;
}

export default function EditJobPage({
  jobId,
  jobFeedActive,
  canAddIndeedDemographicQ
}: IEditJobProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <EditJob
        {...{
          jobId,
          jobFeedActive,
          canAddIndeedDemographicQ
        }}
      />
    </QueryClientProvider>
  );
}
